import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificacionesService } from '../../../services/certificaciones/certificaciones.service';
import { Certificacion } from '../../../../model/class/Certificacion';
import * as _ from 'lodash';
import { CrearCertificacionesComponent } from '../crear-certificaciones/crear-certificaciones.component';

@Component({
  selector: 'app-listado-certificaciones',
  templateUrl: './listado-certificaciones.component.html',
  styleUrls: ['./listado-certificaciones.component.css']
})
export class ListadoCertificacionesComponent implements OnInit {

  loader = {
    tabla: false
  };

  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();

  page = 1;
  perPage = 20;
  totalData = 0;
  orderSelected: any;
  certiTodas: Certificacion[] = [];

  headerTable: any[] = [
    {
      text: 'Marca',
      value: 'nombre'
    }, {
      text: 'Productos',
      value: 'totalProductos'
    }
  ];

  constructor(
    private modalService: NgbModal,
    private certificacionesService: CertificacionesService,
  ) {
    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.textoBuscar = model.toString();
        this.loadCerti();
      });
  }

  ngOnInit() {
    this.loadCerti();
  }

  onTextoBuscarChange(texto: string) {
    this.textoBuscarChanged.next(texto);
  }

  private loadCerti() {
    this.loader.tabla = true;
    this.certiTodas = [];
    const parametros: any = {};
    let texto: string;

    if (this.textoBuscar) {
      texto = this.textoBuscar.trim();
    }
    if (texto) {
      const objetoBucar: any = [{ 'name': texto }];
      parametros.search = JSON.stringify(objetoBucar);
    }
    const paginador = {
      since: (this.page - 1) * this.perPage,
      quantity: this.perPage
    };
    parametros.paginator = JSON.stringify(paginador);

    this.certificacionesService.get(parametros)
      .subscribe(
        (response) => {
          this.loader.tabla = false;
          this.totalData = response.total;
          for (const iCer of response.data) {
            this.certiTodas.push(new Certificacion(iCer));
          }
          this.orderData();
        }, (error) => {
          this.loader.tabla = false;
        }
      );
  }

  limpiarTexto() {
    this.textoBuscar = '';
    this.loadCerti();
  }

  changeValueOrder(index: number) {
    if (this.headerTable[index].value) {
      for (let i = 0; i < this.headerTable.length; i++) {
        if (i === index) {
          if (this.headerTable[i].order === 'desc') {
            this.headerTable[i].order = 'asc';
          } else if (this.headerTable[i].order === 'asc') {
            this.headerTable[i].order = 'desc';
          } else if (!this.headerTable[i].order) {
            this.headerTable[i].order = 'asc';
          }
        } else {
          this.headerTable[i].order = undefined;
        }
      }
      this.orderSelected = this.headerTable[index];
      this.orderData();
    }
  }

  orderData() {
    if (this.orderSelected) {
      this.certiTodas = _.orderBy(this.certiTodas, this.orderSelected.value, this.orderSelected.order);
    }
  }

  pageChange(event) {
    this.page = event;
    this.loadCerti();
  }

  crearEditarCerti(certi?: Certificacion) {
    let clon: any = {};
    if (certi) {
      clon = _.clone(certi);
    }

    const viewModal = this.modalService.open(CrearCertificacionesComponent, { size: 'lg', windowClass: 'modal-admin' });
    viewModal.componentInstance.newCerti = clon;

    viewModal.result
      .then((newCerti: Certificacion) => {
        const newObj = new Certificacion(newCerti);
        if (clon.id) {
          // Editando
          const indice = _.findIndex(this.certiTodas, { id: newObj.id });
          if (indice >= 0) {
            this.certiTodas[indice] = newObj;
          }
        } else {
          // Nuevo
          if (this.certiTodas.length < this.perPage) {
            this.certiTodas.push(newObj);
          }
        }
      }, (reason) => {
      });

  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/listado-certificaciones/listado-certificaciones.component.ts